import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('', 'mail');

tbl.add(new Xtc('user', 'User'))
tbl.add(new Xtc('email', 'Email'))

export default tbl;

